import React, { useContext, useEffect, useState } from "react";
import { CustomerContext } from "../../context/CustomerContext";
import { ModalContext } from "../../context/ModalContext";
import PanelTitle from "../../components/global/PanelTitle";
import CustomerData from "../../components/customers/CustomerData";
import CustomerActions from "../../components/customers/CustomerActions";
import StreaksTable from "../../components/streaks/StreaksTable";
import NotesOffcanvas from "../../components/notes/NotesOffcanvas";
import { NotesContext } from "../../context/NotesContext";
import AdminAvailableClasses from "./AdminAvailableClasses";
import OnlineAccessTable from "../../components/customers/OnlineAccessTable";
import ReservationsTable from "../../components/reservaciones/ReservationsTable";
import ReservationTableFilters from "../../components/reservaciones/ReservationTableFilters";
import ConfirmDelete from "../../components/global/ConfirmDelete";
import CustomerInvoices from "../../components/invoices/CustomerInvoices";
import { navigate } from "@reach/router";
import CustomerPurchases from "../../components/purchases/CustomerPurchases";

const AdminSingleUsuario = ({ customer_id }) => {
  const [currentTab, setCurrentTab] = useState("Compras");

  const { customer, getCustomer, clearCustomer, deleteCustomer } =
    useContext(CustomerContext);

  const { clearModal, modalComponent, offcanvasComponent } = useContext(ModalContext);
  const { getNotesByCustomer } = useContext(NotesContext);

  useEffect(() => {
    getViewData();
    return clearCustomer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer_id]);

  const getViewData = () => {
    getCustomer(customer_id);
  };

  const confirmDelete = () => {
    modalComponent(
      "Precaución",
      <ConfirmDelete
        message={`¿Estás segura que deseas eliminar el cliente ${customer.name}{" "}
          ${customer.last_name} con el correo ${customer.email}?`}
        handleDelete={() => deleteCustomer(customer_id)}
        handleCancel={clearModal}
      />
    );
  };

  const renderPanel = () => {
    if (customer && customer !== null) {
      return (
        <div className="row">
          <div className="col-12 col-md-6">
            <CustomerData
              customer={customer}
              handleEdit={() =>
                navigate(`/myadmin/customer/${customer_id}/edit`)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <CustomerActions
              handleNotesOffcanvas={handleNotesOffcanvas}
              handleCallback={getViewData}
              customer={customer}
            />
          </div>
        </div>
      );
    }
    return <div className="spinner-border"></div>;
  };

  const handleNotesOffcanvas = () => {
    offcanvasComponent(
      "Notas",
      <NotesOffcanvas
        customer_id={customer_id}
        handleCallback={() => getNotesByCustomer(customer_id)}
      />
    );
  };

  const renderNotesBtn = () => {
    return (
      <li
        className={`nav-item customer-nav-item hide-mobile`}
        onClick={() => {
          handleNotesOffcanvas();
        }}
      >
        <p className={`nav-link mb-0 text-dark `}>Notas</p>
      </li>
    );
  };

  const renderTabs = () => {
    const tabs = [
      "Compras",
      "Cargos",
      "Streaks",
      "Reservaciones",
      "Clases",
      "Accesos",
    ];

    return tabs.map((tab) => {
      const active = tab === currentTab ? true : false;

      return (
        <li
          key={tab}
          className={`nav-item customer-nav-item`}
          onClick={() => setCurrentTab(tab)}
        >
          <p
            className={`nav-link mb-0 ${
              active ? "bg-primary text-white" : "text-dark"
            } `}
          >
            {tab}
          </p>
        </li>
      );
    });
  };

  const renderContent = () => {
    if (!customer || customer === null) {
      return <div className="spinner-border"></div>;
    }
    switch (currentTab) {
      case "Cargos":
        return <CustomerInvoices customer_id={customer_id} />;
      case "Clases":
        return <AdminAvailableClasses customer_id={customer_id} />;
      case "Streaks":
        return <StreaksTable customer_id={customer_id} />;
      case "Reservaciones":
        return (
          <div className="card no-scale my-3">
            <PanelTitle title="Reservaciones" hideButton />
            <ReservationTableFilters />
            <ReservationsTable customer_id={customer_id} />
          </div>
        );
      case "Accesos":
        return <OnlineAccessTable customer_id={customer_id} />;
      default:
        return <CustomerPurchases customer_id={customer_id} />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row pb-2 border-bottom mx-0 mb-3 align-items-center">
        <div className="col col-md-6 ps-0">
          <h1>Cliente</h1>
        </div>
        <div className="col col-md-6 pe-0 text-end"></div>
      </div>
      <div className="card no-scale mb-3">{renderPanel()}</div>

      <div className="card p-3 my-3">
        <div className="row mx-auto w-100">
          <div className="col-12 px-0">
            <ul className="nav nav-pills customer-nav">
              {renderTabs()}
              {renderNotesBtn()}
            </ul>
          </div>
        </div>
      </div>

      {renderContent()}

      <button className="btn btn-outline-danger mt-5" onClick={confirmDelete}>
        <i className="fa fa-trash"></i> Eliminar Cliente
      </button>
    </div>
  );
};

export default AdminSingleUsuario;
